export default "__VITE_ASSET__ODDd7xpL__"